<mat-card>
  <mat-card-content>
    <div class="d-flex d-md-block align-items-center">
      <mat-card-title>Product Performance</mat-card-title>
      <div class="ml-auto">
        <mat-form-field class="theme-select" appearance="outline">
          <mat-select value="one">
            <mat-option value="one">May 2022</mat-option>
            <mat-option value="two">June 2022</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="w-100 m-t-15">
        <!--- Note that these columns can be defined in any order.
                              The actual rendered columns are set as a property on the row definition" -->

        <!-- Position Column -->
        <ng-container matColumnDef="assigned">
          <th mat-header-cell *matHeaderCellDef class="p-l-0 text-muted">
            Assigned
          </th>
          <td mat-cell *matCellDef="let element" class="p-l-0">
            <div class="d-flex align-items-center">
              <img
                [src]="element.imagePath"
                alt="users"
                width="40"
                class="rounded-circle"
              />
              <div class="m-l-15">
                <h6 class="mat-subheading-2 lh-md fw-bold m-t-0 m-b-0">
                  {{ element.uname }}
                </h6>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="text-muted">Name</th>
          <td mat-cell *matCellDef="let element" class="text-muted fw-medium">
            {{ element.productName }}
          </td>
        </ng-container>

        <!-- Weight Column -->
        <ng-container matColumnDef="priority">
          <th mat-header-cell *matHeaderCellDef class="text-muted">Priority</th>
          <td mat-cell *matCellDef="let element">
            <ng-template [ngIf]="element.priority == 'low'">
              <mat-chip color="accent" selected>{{
                element.priority | titlecase
              }}</mat-chip>
            </ng-template>
            <ng-template [ngIf]="element.priority == 'medium'">
              <mat-chip color="primary" selected>{{
                element.priority | titlecase
              }}</mat-chip>
            </ng-template>
            <ng-template [ngIf]="element.priority == 'high'">
              <mat-chip class="bg-warning" selected>{{
                element.priority | titlecase
              }}</mat-chip>
            </ng-template>
            <ng-template [ngIf]="element.priority == 'critical'">
              <mat-chip class="bg-danger" selected>{{
                element.priority | titlecase
              }}</mat-chip>
            </ng-template>
            <ng-template [ngIf]="element.priority == 'moderate'">
              <mat-chip class="bg-success" selected>{{
                element.priority | titlecase
              }}</mat-chip>
            </ng-template>
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="budget">
          <th mat-header-cell *matHeaderCellDef class="p-r-0 text-muted">
            Budget
          </th>
          <td mat-cell *matCellDef="let element" class="fw-medium p-r-0">
            ${{ element.budget }}k
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
